export default __webpack_public_path__ + "static/media/cc_0.d2081fb9.mp3";